import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@core-ui/Components/ui/button.tsx';

interface SalesforceDebugDialogProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: string;
}

export function SalesforceDebugDialog ({
  isOpen,
  onOpenChange,
  data,
}: SalesforceDebugDialogProps): React.JSX.Element {
  const { t } = useTranslation();
  
  const printPrettyJson = (): string => {
    return JSON.stringify(JSON.parse(data), null, 1);
  };
  
  // Using a custom dialog component, because the Dialog from the shared components is not resizable.
  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => {
              onOpenChange(false); 
            }}
            aria-hidden
          />

          <div
            role="dialog"
            aria-modal="true"
            className="relative bg-card border border-border text-card-foreground rounded-md shadow p-6 max-w-[90vw] max-h-[90vh]"
            onClick={(e) => {
              e.stopPropagation(); 
            }}
          >
            <header className="flex items-start justify-between px-4 py-3">
              <div>
                <div className="font-medium">{t('contacts.salesforceDebugDialog.title')}</div>
                <div className="text-sm text-muted-foreground">{t('contacts.salesforceDebugDialog.description')}</div>
              </div>
            </header>
            
            <main className={`rounded-md border border-border p-3 mb-4 ${data !== '' ? 'w-full max-h-[70vh] overflow-y-auto' : 'max-h-20'}`}>
              {(data !== '') ? (
                <pre className="text-sm whitespace-pre-wrap block">
                  {printPrettyJson()}
                </pre>
              ) : (
                <div className="text-sm text-muted-foreground">{t('contacts.salesforceDebugDialog.noData')}</div>
              )}
            </main>
            
            <footer>
              <div className="flex justify-end">
                <Button onClick={() => {
                  onOpenChange(false); 
                }}>{t('contacts.salesforceDebugDialog.close')}</Button>
              </div>
            </footer>
          </div>
        </div>
      )}
    </>
  );
}
